import { Component, Input } from '@angular/core';

@Component({
    // eslint-disable-next-line @angular-eslint/component-selector
    selector: 'atom-filter-button',
    templateUrl: './atom-filter-button.component.html',
    standalone: false,
})
export class AtomFilterButtonComponent {
    @Input() cySelector?: string;
}
